module.exports = __webpack_public_path__ + "img/tu_file_ppt.be5e48e1.svg";